import React, { useState, useRef, useEffect } from "react";
import { Document, Page, pdfjs } from 'react-pdf';
import throttle from 'lodash/throttle';
import getEnvEndpoints from "./../../../utils/endpoints";

const PdfViewer = ({ fragment, fragmentZoom, fragmentId, path = '' }) => {
  const endpoints = getEnvEndpoints();
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`
  const [initialWidth, setInitialWidth] = useState(null);
  let fragmentPath = fragment.fields?.Content || ''
  if (fragmentPath === '' && endpoints.pmbok7TocUrl) {
    fragmentPath = endpoints.pmbok7TocUrl && endpoints.pmbok7TocUrl || ''
  }
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  }

  const pdfWrapper = useRef(null);
  const setPdfSize = () => {
    if (pdfWrapper && pdfWrapper.current) {
      setInitialWidth(pdfWrapper.current.getBoundingClientRect().width);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', throttle(setPdfSize, 1000));
    setPdfSize();
    return () => {
      window.removeEventListener('resize', throttle(setPdfSize, 1000));
    };
  }, []);
  return (
    <>
      <div className="main -ml-8 overflow-hidden" ref={pdfWrapper}>
        <Document file={fragmentPath} onLoadSuccess={onDocumentLoadSuccess} key={fragmentId || path} loading={(<div className="h-64 my-10 mt-12 ml-16" style={{ height: `calc(100vh - 50%)` }}><div className="flex justify-center" ><i className="fas fa-spinner fa-spin" /></div></div>)}>
          {Array.apply(null, Array(numPages))
            .map((x, i) => i + 1)
            .map(page => <Page wrap={false} key={page} pageNumber={page} scale={fragmentZoom} width={initialWidth} />)}
        </Document>
      </div>
    </>
  );
}

export default PdfViewer;
